import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

import { TranslationLanguage, TranslationsConfiguration } from '../Models/Translations';

export const TranslationsAPI = (baseURL: string | undefined, clientId: string) => {
	const api = AxiosAPI({
		baseURL,
		clientId,
		isApp: true,
		hasUnderMaintenance: false
	});

	const getTranslations = () => {
		const serviceUrl = '/bookbuilding-api/Translations';
		return api.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const saveTranslations = (data: TranslationsConfiguration) => {
		const serviceUrl = '/bookbuilding-api/Translations';
		return api.put(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const createLanguage = (data: TranslationLanguage) => {
		const serviceUrl = '/bookbuilding-api/Translations/language';
		return api.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	return {
		getTranslations,
		saveTranslations,
		createLanguage
	};
};
